import { PublicClientApplication } from '@azure/msal-browser';

// Always use window.location.origin for redirect URI to ensure it works with custom domains
// This is more reliable than build-time env vars which may not be set correctly
const redirectUri = window.location.origin;

// Debug logging (remove in production if desired)
// if (import.meta.env.DEV) {
//   console.log('MSAL Config:', {
//     redirectUri,
//     envRedirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI,
//     windowOrigin: window.location.origin,
//     href: window.location.href,
//   });
// }

const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
  // Request roles claim in the token
  extraQueryParameters: {
    claims: JSON.stringify({
      id_token: {
        roles: null,
      },
    }),
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL
await msalInstance.initialize();
